export default "__VITE_ASSET__C7bO3bWR__"